import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAuthState } from "../../../../MainComponents/GlobalContext";
import HelmetTags from "../../../../MainComponents/HelmetTags";
import { Link } from "react-router-dom";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import SingleCourse from "../../../../MainComponents/SingleCourse";
import useAxios from "../../../../MainComponents/Hooks/useAxios";
import { Loader } from "../../../../MainComponents";
import { useQueryState, parseAsInteger } from "nuqs";

function AdminExams() {
  const AuthState = useAuthState();
  const [reFetch, setReFetch] = useState(false);
  const [allExamsData, allExamsErrors, allExamsloading] = useAxios(
    process.env.REACT_APP_ADMIN_TRIAL_EXAMS_TAB_API,
    "GET",
    "GET",
    reFetch
  );

  const [academicLevel, setAcademicLevel] = useQueryState("level", {
    defaultValue: "11",
  });

  const filteredExams = allExamsData?.data?.filter((exam) => {
    return +exam.stage === +academicLevel;
  });

  return (
    <section className="h-full w-full overflow-y-auto px-20 py-20 sm:px-10 ">
      <HelmetTags title="الإختبارات | مسيو بلال عبدالله"></HelmetTags>
      <div className="mb-32 flex flex-col items-end gap-20">
        <h2 className="w-full text-end text-4xl font-bold md:text-center">
          الإختبارات
        </h2>{" "}
        {(AuthState.userData?.admin?.roles[0]?.name === "superadmin" ||
          AuthState.userData?.admin?.permissions?.some((permission) =>
            permission.name.startsWith("exam_add")
          )) && (
          <div className="flex w-full justify-end gap-10 md:justify-evenly">
            <Link
              to="/admin/exams/add-exam"
              className="ml-4 rounded-xl border-2 border-secondary bg-light px-2 py-1 font-semibold text-secondary transition-all duration-300 hover:bg-secondary hover:text-light   active:scale-90 "
            >
              <FontAwesomeIcon className="mr-4" icon={faPlus} />
              اضافة إختبار
            </Link>
          </div>
        )}
        <div className="flex w-full  pb-20 justify-end gap-10 md:justify-center md:flex-col-reverse sm:items-center">
          <button
            onClick={() => {
              setAcademicLevel("3");
            }}
            className={`md:w-full flex items-center justify-center rounded-xl border-2 border-secondary  px-2 py-1 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
              academicLevel === "3" && "bg-secondary text-light"
            }`}
          >
            الصف الثالث الثانوي
          </button>

          <button
            onClick={() => {
              setAcademicLevel("2");
            }}
            className={`md:w-full flex items-center justify-center rounded-xl border-2 border-secondary  px-2 py-1 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
              academicLevel === "2" && "bg-secondary text-light"
            }`}
          >
            الصف الثاني الثانوي
          </button>
          <button
            onClick={() => {
              setAcademicLevel("1");
            }}
            className={`md:w-full flex items-center justify-center rounded-xl border-2 border-secondary  px-2 py-1 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
              academicLevel === "1" && "bg-secondary text-light"
            }`}
          >
            الصف الأول الثانوي
          </button>
          <button
            onClick={() => {
              setAcademicLevel("33");
            }}
            className={`md:w-full flex items-center justify-center rounded-xl border-2 border-secondary  px-2 py-1 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
              academicLevel === "33" && "bg-secondary text-light"
            }`}
          >
            ثالثة الاعدادي
          </button>
          <button
            onClick={() => {
              setAcademicLevel("22");
            }}
            className={`md:w-full flex items-center justify-center rounded-xl border-2 border-secondary  px-2 py-1 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
              academicLevel === "22" && "bg-secondary text-light"
            }`}
          >
            ثانية الاعدادي
          </button>
          <button
            onClick={() => {
              setAcademicLevel("11");
            }}
            className={`md:w-full flex items-center justify-center rounded-xl border-2 border-secondary  px-2 py-1 font-semibold  transition-all duration-300 hover:bg-light hover:text-secondary   active:scale-90 ${
              academicLevel === "11" && "bg-secondary text-light"
            }`}
          >
            أولى الاعدادي
          </button>
        </div>
        {allExamsloading ? (
          <Loader />
        ) : (
          <div className="lectures grid-auto-fit w-full">
            {filteredExams?.length === 0 ? (
              <p>لا يوجد الإختبارات</p>
            ) : (
              filteredExams?.map((Card) => (
                <SingleCourse
                  reFetch={reFetch}
                  setReFetch={setReFetch}
                  admin
                  exam
                  lecture={Card}
                  key={Card.key}
                />
              ))
            )}
          </div>
        )}
      </div>
    </section>
  );
}

export default AdminExams;
